import React from 'react';
import { TableRow, TableCell } from '@insurancemenu/imenu-components-lib';
import { dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import clsx from 'clsx';
import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { Cart } from 'types/cartServiceV2';
import {
  PRODUCT_LINES_CONTENT_MAP,
  sortByProductLineId,
} from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { useHistory } from 'react-router-dom';
import { RateSegmentInfo, RATE_SEGMENT_INFO } from 'global/utils/RateSegmentHelper';
import { createStyles } from './styles';
import MoreDropdown from '../MoreDropdown';

export interface FavoriteProposalsRowProps {
  cart: Cart;
}

const FavoriteProposalsRow = ({ cart }: FavoriteProposalsRowProps): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();

  const { id, cartName, creationDateTime, rateSegment, cartItems, groupId } = cart;

  const productLineIds = [...new Set(cartItems.map(({ productLineId }) => productLineId).sort(sortByProductLineId))];

  const joinedProductLines = productLineIds
    .map((productLineId) => PRODUCT_LINES_CONTENT_MAP[productLineId].label)
    .join(', ');

  const editProposalTemplate = (): void => {
    const firstProductLineId = productLineIds[0];

    switch (rateSegment) {
      case 'GROUP':
      case 'ASSOCIATION':
        history.push(`/browsing?groupId=${groupId}&productLineId=${firstProductLineId}&cartId=${id}&type=template`);
        break;
      case 'CUSTOM':
        break;
      case 'INDIVIDUAL':
        break;

      default:
        history.push(`/browsing?groupId=${groupId}&productLineId=${firstProductLineId}&cartId=${id}`);
        break;
    }
  };

  return (
    <TableRow className={classes.tableRow} key={id}>
      <TableCell className={classes.tableCell} onClick={editProposalTemplate}>
        {cartName}
      </TableCell>
      <TableCell className={classes.tableCell}>
        <div
          className={clsx(classes.tag, classes[`tagType_${rateSegment as Extract<RateSegment, 'GROUP' | 'CUSTOM'>}`])}
        >
          {RATE_SEGMENT_INFO[rateSegment as keyof RateSegmentInfo]?.label}
        </div>
      </TableCell>
      <TableCell className={classes.tableCell}>
        {dateFormatters.normDateToShortAmericanDate(creationDateTime)}
      </TableCell>
      <TableCell className={classes.tableCell}>{joinedProductLines}</TableCell>
      <TableCell className={classes.tableCell}>
        <MoreDropdown cart={cart} editProposalTemplate={editProposalTemplate} />
      </TableCell>
    </TableRow>
  );
};

export default FavoriteProposalsRow;
